module.exports = __webpack_public_path__ + "img/ico_vencedor2_active.dfd65380.png";